import { GET_ALL_SEVERITY } from '../../types'

const INITIAL_STATE = {
  getAllSeverity: [],
}

const severityReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_SEVERITY:
      return {
        ...state,
        getAllSeverity: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default severityReducer
